<script lang="ts">
	interface Pilltype {
		pos: 'TL' | 'TR' | 'BL' | 'BR' | 'C'; // TopLeft, TopRight...etc
		text: string;
		subText?: string;
		color?: 'red' | 'grey' | 'white';
		icon?: string;
	}

	export let pills: Pilltype[];
	export let darkended = false;

</script>

<article class="status-pill {darkended ? 'dark' : ''}">
	{#each pills as pill}
		<div style={pill.text === '' ? 'display: none' : ''}  class="{pill.color} {pill.pos}">
			{#if pill.icon}
				<span class="{pill.icon}" style="margin-right: 3px;"></span>
			{/if}

			<span class="label-xs">
					{pill.text}{#if pill.subText}:&nbsp{/if}
			</span>

			{#if pill.subText}
				<span style="font-weight: 500;">{pill.subText}</span>
			{/if}

		</div>
	{/each}
</article>

<style lang="scss">
	@use 'color';

	.status-pill {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		&.dark {
			&:before {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0,0,0,.55);
				content: '';
				z-index: 1;
			}
		}
		div {
			position: absolute;
			border-radius: 20px;
			padding: 3px 7px;
			line-height: 1rem;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			font-size: 0.7rem;
			background: color.$red-2;
			color: color.$white;
			&.TL { top: 6px; left: 6px; }
			&.TR { top: 6px; right: 6px; }
			&.BL { bottom: 6px; left: 6px; }
			&.BR { bottom: 6px; right: 6px; }
			&.C { top: 50%; left: 50%; transform: translate(-50%, -50%); }
			&.grey { background: color.$dark-pill; }
			&.white {
				width: max-content;
				max-width: 98%;
				background: color.$white;
				color: color.$black;
				border: 2px solid color.$black;
				font-size: .88rem;
				padding: 5px 7px;
				z-index: 2;
			}
			span { margin: 0; }
		}
	}
</style>